import React from 'react';
import successgif from '../../assets/p_success.gif';

const SuccessMessage = () => (
  <div className="w-full max-w-lg p-6 m-6 bg-gradient-to-t from-green-100 to-white rounded-lg shadow-md grid place-items-center">
    <div className='flex flex-col justify-center items-center'>
      <img src={successgif} alt='payment_successul' className='h-[100px] w-[100px]' />
      <p className='text-xs font-lufga'>Payment Successful</p>
      <p className='text-xs font-lufga'>redirecting....</p>
    </div>
  </div>
);

export default SuccessMessage; 